import { useTranslation } from 'react-i18next';
import Section, { SectionPropsType } from '../Section/Section';
import './SummarySection.css';
import IconText from '../IconText/IconText';
import ChevronLink from '../ChevronLink/ChevronLink';
import { SummarySectionListItemType } from '../../../types/SummarySectionListItemType';

type Props = {
    summaryItems: SummarySectionListItemType[];
    contentClassName?: string;
    sectionProps?: SectionPropsType;
};

const SummarySection = ({ summaryItems, contentClassName, sectionProps }: Props) => {
    const { t } = useTranslation();
    return (
        <Section
            title={t('summary')}
            contentClassName={`summarySectionList ${contentClassName ?? ''}`}
            {...sectionProps}
        >
            {summaryItems.map((item, index) => {
                const { nested = false, type = 'text', linkUrl, ...rest } = item;
                return type === 'text' ? (
                    <IconText key={index} className={`${nested ? 'nested' : ''}`} {...rest} />
                ) : (
                    <ChevronLink
                        key={index}
                        chevronDirection='right'
                        className={`${nested ? 'nested' : ''}`}
                        linkUrl={linkUrl}
                    >
                        <IconText key={index} className={`${nested ? 'nested' : ''}`} {...rest} />
                    </ChevronLink>
                );
            })}
        </Section>
    );
};

export default SummarySection;
